import React from "react";
import {IconNames} from "@blueprintjs/icons";
import {Button, Dialog} from "@blueprintjs/core";
import InfiniteScroll from "react-infinite-scroll-component";

import {IBlock} from '../../../../../../shared/models';
import PDFMergeOptionsForm from './PDFMergeOptionsForm';
import FilenameInput from '../FilenameInput';

interface PDFDialogOptionsProps {
  isPDFDialogOpen: boolean;
  setIsPDFDialogOpen: (value: boolean) => void;
  mergePdfConfig: any;
  pdfMergeContent: IBlock[];
  onMergePdfFilenameChange: (value: any) => void;
  onUpdateMergePdfOption: (uid: string, updatedValues: any) => void;
  savePdfMergeOptions: () => void;
  readOnly: boolean;
  content: any[];
}

const PDFDialogOptions = ({
  isPDFDialogOpen,
  setIsPDFDialogOpen,
  mergePdfConfig,
  pdfMergeContent,
  onMergePdfFilenameChange,
  onUpdateMergePdfOption,
  savePdfMergeOptions,
}: PDFDialogOptionsProps) => {

  const getOption = (uid: string) => {
    return mergePdfConfig.options.find((opt: any) => opt.uid === uid)
  }

  return (
    <Dialog isOpen={isPDFDialogOpen} onClose={() => setIsPDFDialogOpen(false)} title="PDF Merge Options"
            icon={IconNames.COG}>
      <div className="pdf-merge-dialog-content">
        <FilenameInput filename={mergePdfConfig.filename} onChange={onMergePdfFilenameChange} type={"pdf"}/>

        <div className="pdf-merge-table-container" id="pdf_merge_infinite_scroll">
          <InfiniteScroll
            dataLength={mergePdfConfig.options?.length || 0}
            next={() => { /* Not implemented yet */}}
            hasMore={false}
            loader={<div>Loading...</div>}
            scrollableTarget="pdf_merge_infinite_scroll"
          >
            <table className="pdf-merge-table">
              <thead>
              <tr className="pdf-merge-header">
                <th>Content</th>
                <th>Include</th>
                <th>Position</th>
              </tr>
              </thead>
              <tbody>
              {mergePdfConfig.enabled &&
                pdfMergeContent.map((content: IBlock, index: number) => (
                  <PDFMergeOptionsForm
                    key={content.uid}
                    uid={content.uid}
                    name={content.name}
                    position={index}
                    option={getOption(content.uid)}
                    onUpdateMergePdfOption={onUpdateMergePdfOption}
                    positionLimit={pdfMergeContent.length}
                  />
                ))}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>

        <div className="pdf-merge-dialog-footer">
          <Button onClick={() => setIsPDFDialogOpen(false)}>Cancel</Button>
          <Button intent="primary" onClick={savePdfMergeOptions}>
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default PDFDialogOptions;
